"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _formSerialize = _interopRequireDefault(require("form-serialize"));

var _fromPairs2 = _interopRequireDefault(require("lodash/fromPairs"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _normalizeValues = function _normalizeValues(data) {
  if (typeof data !== 'object') {
    return data;
  }

  if (Array.isArray(data)) {
    if ((0, _isEqual2.default)(data, Object.values(data))) {
      return data.filter(function (value) {
        return value !== '';
      }).map(function (value) {
        return _normalizeValues(value);
      });
    }

    data = (0, _fromPairs2.default)(Object.entries(data));
  }

  return (0, _mapValues2.default)(data, function (value) {
    return _normalizeValues(value);
  });
};

var serializeForm = function serializeForm($$form) {
  var data = (0, _formSerialize.default)($$form, {
    hash: true,
    empty: true
  });
  return _normalizeValues(data);
};

var _default = serializeForm;
exports.default = _default;